import { logMaxFontSize } from "store/javascripts/utils/debug-loggers";

//@ts-check
export const minNominalFontSize = 1;
export const minScaledFontSize = 12;

export const maxNominalFontSize = 600;
export const maxScaledFontSize = 1200;

export const getSituationalMaxScaledFontSize = ({
  columnCount,
  textLength,
  columnsDeterminedAutomatically,
}) => {
  logMaxFontSize(
    `Calculating situational max font size (columnCount: ${columnCount}, textLength: ${textLength}, columnsDeterminedAutomatically: ${columnsDeterminedAutomatically})`
  );
  if (columnsDeterminedAutomatically) {
    // If columns are automatic, font-scaler will set columnCount to 1
    // if the font-size is too large.
    return null;
  }
  if (!textLength || textLength <= 0) {
    return null;
  }

  if ((columnCount ?? 1) === 1) {
    return null;
  }

  let maxFontSize;
  if (textLength >= 6000) {
    maxFontSize = 50;
  } else if (textLength >= 5000) {
    maxFontSize = 100;
  } else if (textLength >= 4000) {
    maxFontSize = 200;
  } else if (textLength >= 3000) {
    maxFontSize = 400;
  } else if (textLength >= 2000) {
    maxFontSize = 450;
  } else if (textLength >= 1000) {
    maxFontSize = 600;
  } else if (textLength >= 300) {
    maxFontSize = 1000;
  } else {
    maxFontSize = 2000;
  }
  /**
  Text character length range => maximum scaled font size for 2 / 3 columns

  6000+ => 50 / 25
  5000-5999 => 100 / 50
  4000-4999 => 200 / 100
  3000-3999 => 400 / 200
  2000-2999 => 450 / 225
  1000-1999 => 600 / 300
  300-999 => 1000 / 500
  0-299 => 2000 / 1000
  */

  // Divide by 2 when the column count is 3
  maxFontSize /= columnCount - 1;

  logMaxFontSize(
    `Situational max font size: ${maxFontSize} (column count: ${columnCount}, text length: ${textLength} ${
      columnsDeterminedAutomatically ? " (automatic columns)" : ""
    })`
  );

  return maxFontSize;
};
